const { debounce } = window.BAO.Utils
const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class StickyImageGridCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slides?.exists || !this.els?.slide?.exists) return

    this.checkSetupCarousel()
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    this.destroyCarousel()
  }

  setupListeners () {
    this.listeners.add(
      window,
      'resize',
      debounce(() => {
        this.checkSetupCarousel()
      }, 500),
    )
  }

  destroyCarousel () {
    if (!this.carousel) return

    this.carousel.destroy()
    this.carousel = null
    this.els?.slides?.element?.removeAttribute('data-initialised')
  }

  checkSetupCarousel () {
    if (window.innerWidth < 1280) {
      if (!this.carousel) {
        this.carousel = this.setupCarousel()
      }

      return
    }

    this.destroyCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.25,
          spacing: 10,
        }
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('sticky-image-grid-carousel')) {
  customElements.define('sticky-image-grid-carousel', StickyImageGridCarousel)
}
